import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HttpFunctionsService {
  baseurl: string =  environment.apiBaseUrl;
  ref: any = "none";
  headerOptions: any = {};
  constructor(private httpClientService: HttpClient,
    private ngxSpinner:NgxSpinnerService,
    private routerActivated: ActivatedRoute,
    private titleService: Title) {
      this.routerActivated.queryParams.subscribe((params: Params) => {
        if (params['ref']) {
          this.ref = params['ref'];
          sessionStorage.setItem("ref", params['ref']);
        }
      });
    }

  /**
   * call common get method
   * @param apiName : string  name of the api 
   * @returns 
   */
  public getMethod(apiName:string, isShowLoader:boolean = true):Observable<any> {
    if (isShowLoader) {
      this.ngxSpinner.show();
    }
    let options: any = {
      headers: {
        "x-ref-by" :  this.ref
      }
    } 
    return this.httpClientService.get(this.baseurl+apiName, options);
  }

    /**
   * Just for testing delete later 
   */
    public getMethodCustom(apiName:string, isSendRef: boolean = true):Observable<any> {
      //this.ngxSpinner.show();
      let options: any = {
      } 
      if (isSendRef) {
        options = {
          headers: {
            "x-ref-by" :  this.ref
          }
        }  
      }
    
      return this.httpClientService.get(apiName, options);
    }

  /**
   * call common get method
   * @param apiName : string  name of the api 
   * @returns 
   */
   public getDataFromAssets(url:string,isShowLoader:boolean = true):Observable<any> {
    if (isShowLoader) {
      this.ngxSpinner.show();
    }
    let options: any = {
      headers: {
        "x-ref-by" :  this.ref
      }
    } 
    return this.httpClientService.get(url, options);
  }

  /**
   * 
   * @param apiName : string
   * @param parameters : object 
   * @returns Observable
   * call common post Method
   */
  public postMethod(apiName:string,parameters:any,isShowLoader:boolean = true) :Observable<any> {
    if (isShowLoader) {
      this.ngxSpinner.show();
    }
    let options: any = {
      headers: {
        "x-ref-by" :  this.ref
      }
    } 
    return this.httpClientService.post(this.baseurl+apiName,parameters, options);
  }

  /**
   * 
   * @param apiName : string
   * @param parameters : object 
   * @returns Observable
   * call common post Method
   */
  public putMethod(apiName:string,parameters:any,isShowLoader:boolean = true) :Observable<any> {
    if (isShowLoader) {
      this.ngxSpinner.show();
    }
    let options: any = {
      headers: {
        "x-ref-by" :  this.ref
      }
    } 
    return this.httpClientService.put(this.baseurl+apiName,parameters, options);
  }

  public putMethodWithProgress(apiName: string, parameters: any, isShowLoader: boolean = false): Observable<any> {
  if (isShowLoader) {
    this.ngxSpinner.show();
  }
  
  const options: any = {
    headers: {
      "x-ref-by": this.ref
    },
    observe: 'events' as 'events',
    reportProgress: true,
  };
  
  return this.httpClientService.put(this.baseurl + apiName, parameters, options);
}

  public deleteMethod(apiName:string, sendData: any = null, isShowLoader:boolean = true) :Observable<any> {
    if (isShowLoader) {
      this.ngxSpinner.show();
    }
    let options: any = {
      headers: {
        "x-ref-by" :  this.ref
      },
      body: sendData
    } 
    return this.httpClientService.delete(this.baseurl+apiName, options);
  }
  public patchMethod(apiName:string, SendData:any,isShowLoader:boolean = true) :Observable<any> {
    if (isShowLoader) {
      this.ngxSpinner.show();
    }
    let options: any = {
      headers: {
        "x-ref-by" :  this.ref
      }
    } 
    return this.httpClientService.patch(this.baseurl+apiName,SendData, options);
  }


  public getMethodWithParams(apiName:string,parameters:any,isShowLoader:boolean = true)  :Observable<any>  {
    if (isShowLoader) {
      this.ngxSpinner.show();
    }
    const HTTP_OPTIONS = {
      params: parameters,
      headers: {
        "x-ref-by" :  this.ref
      }
    }

    return this.httpClientService.get(this.baseurl+apiName,HTTP_OPTIONS);
  }


  /**
   * Set Browser Title dynamically
   * @param titleName 
   */
  setTitleService(titleName:string) {
    let originName =  window.origin === 'https://illpeoplemusic.com' ? "IllPeopleMusic" : "Beat22";
    const newTitle = originName+" - "+titleName;
    this.titleService.setTitle(newTitle);
  }

   /**
   * POST method that returns raw blob response (e.g. direct binary file downloads)
   * @param apiName API endpoint
   * @param parameters request body
   * @param isShowLoader show spinner
   * @returns Observable<Blob>
   */
  public postMethodBlob(apiName: string, parameters: any, isShowLoader: boolean = true): Observable<Blob> {
    if (isShowLoader) {
      this.ngxSpinner.show();
    }
    return this.httpClientService.post(this.baseurl + apiName, parameters, {
      headers: { 'x-ref-by': this.ref },
      responseType: 'blob'
    });
  }
}
